'use client';

import { Loader } from '@/components/ui/loader';
import { cn } from '@/lib/utils';

interface PublicFullScreenLoaderProps {
  message?: string;
  subtitle?: string;
  className?: string;
}

/** Overlay a pantalla completa para transiciones en rutas públicas */
export function PublicFullScreenLoader({
  message = 'Cargando...',
  subtitle = 'Un momento',
  className,
}: PublicFullScreenLoaderProps) {
  return (
    <output
      aria-busy
      aria-label={message}
      className={cn(
        'fixed inset-0 z-[200] flex flex-col items-center justify-center',
        'bg-background/92 backdrop-blur-md',
        'animate-in fade-in duration-200',
        className,
      )}
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[url('/grid.svg')] bg-center opacity-[0.03] [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]"
        aria-hidden
      />
      <div className="relative flex flex-col items-center gap-4 px-6">
        <Loader size="lg" text={message} />
        {subtitle ? (
          <p className="text-sm text-muted-foreground/80 animate-pulse">{subtitle}</p>
        ) : null}
      </div>
    </output>
  );
}
